import emailValidator from "email-validator";

export function validateEmail(email) {
  return emailValidator.validate(email);
}

export function validatePassword(password) {
  const passwordIsValid =
    password.search(/[0-9]/) === -1 ||
    password.search(/[A-Z]/) === -1 ||
    password.search(/[a-z]/) == -1 ||
    password.length < 6;

  return passwordIsValid;
}

export const idRegex = /^([0-9A-Fa-f]){24}$/;

export const clubCreatedByUsLabel = "racketpal-team";
